import { render } from "./Tip.vue?vue&type=template&id=652c8cd6"
import script from "./Tip.vue?vue&type=script&setup=true&lang=js"
export * from "./Tip.vue?vue&type=script&setup=true&lang=js"

import "./Tip.vue?vue&type=style&index=0&id=652c8cd6&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/Tip.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "652c8cd6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('652c8cd6', __exports__)) {
    api.reload('652c8cd6', __exports__)
  }
  
  module.hot.accept("./Tip.vue?vue&type=template&id=652c8cd6", () => {
    api.rerender('652c8cd6', render)
  })

}


export default __exports__